import {
  publishRunQuery,
  watchPublishRunsByApiQuery,
} from "@/api/publish_runs";
import { FetchPolicy } from "apollo-boost";
import {
  extractAndFilterItemsOrProvideDefault,
  extractData,
  extractPropOrThrow,
} from "./utils";
import { IQueryListPublishRunsByApiArgs } from "@/generated/types";
import Observable from "zen-observable";

export interface IPublishRunResponseMappableProps {
  id: string;
  createdAt: string;
}

export const mapResponseToPublishRun = <
  T extends IPublishRunResponseMappableProps,
>(
  data: T,
) => {
  return {
    ...data,
    createdAt: new Date(data.createdAt),
  };
};

export async function getPublishRun(id: string, fetchPolicy?: FetchPolicy) {
  const response = await publishRunQuery({ id }, fetchPolicy);

  return mapResponseToPublishRun(
    extractPropOrThrow(extractData(response), "publishRun"),
  );
}

export function watchPublishRunsByApi(
  variables: IQueryListPublishRunsByApiArgs,
) {
  const { observable, ...rest } = watchPublishRunsByApiQuery(variables);

  return {
    observable: observable.map((response) => {
      const publishRunsByApi = extractPropOrThrow(
        extractData(response),
        "listPublishRunsByApi",
      );

      return {
        ...publishRunsByApi,
        items: extractAndFilterItemsOrProvideDefault(publishRunsByApi).map(
          (publishRun) => mapResponseToPublishRun(publishRun),
        ),
      };
    }),
    ...rest,
  };
}

export type IPublishRunItem = (ReturnType<
  typeof watchPublishRunsByApi
>["observable"] extends Observable<infer T>
  ? T
  : never)["items"][number];
